import React, { useState } from 'react';
import './header.css';
import logo from '../../assets/logo.png';
import Bars from '../../assets/bars.png';
import { Link } from 'react-scroll';

const Header = () => {
    const [menuOpened, setMenuOpened] = useState(false);
    const mobile = window.innerWidth <= 768;

    return (
        <div className="header">
            <img src={logo} alt="" className="logo" />

            {/* Bars icon toggle button for mobile */}
            {mobile && !menuOpened && (
                <div
                    onClick={() => setMenuOpened(true)} // ✅ Add this
                    style={{
                        backgroundColor: 'var(--appColor)',
                        padding: '0.5rem',
                        borderRadius: '5px',
                        cursor: 'pointer',
                    }}
                >
                    <img src={Bars} alt="menu" style={{ width: '1.5rem', height: '1.5rem' }} />
                </div>
            )}

            {/* Show menu if not mobile or menu is opened */}
            {(menuOpened || !mobile) && (
                <ul className="header-menu">
                    <li>
                        <Link to="Home" span={true} smooth={true} onClick={() => setMenuOpened(false)}>
                            Home
                        </Link>
                    </li>
                    <li>
                        <Link to="Programs" span={true} smooth={true} onClick={() => setMenuOpened(false)}>
                            Programs
                        </Link>
                    </li>
                    <li>
                        <Link to="reasons" span={true} smooth={true} onClick={() => setMenuOpened(false)}>
                            Why us
                        </Link>
                    </li>
                    <li>
                        <Link to="Testimonial" span={true} smooth={true} onClick={() => setMenuOpened(false)}>
                            Testimonial
                        </Link>
                    </li>
                    <li>
                        <Link to="about" span={true} smooth={true} onClick={() => setMenuOpened(false)}>
                            about us
                        </Link>
                    </li>
                </ul>
            )}
        </div>
    );
};

export default Header;
